



































import {
  computed,
  defineComponent, PropType, ref,
} from '@nuxtjs/composition-api';

import LoaderScoped from '~/components/common/LoaderScoped.vue';
import { getVimeoId, getYouTubeId } from '~/helpers/productHelpers';
import { Video } from '~/modules/catalog/types';

export default defineComponent({
  name: 'SimpleVideo',
  components: { LoaderScoped },
  props: {
    video: {
      type: Object as PropType<Video>,
      required: true,
    },
    previewUrl: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const videoStarted = ref<boolean>(false);
    const iframeLoaded = ref<boolean>(false);

    const initVideo = () => {
      videoStarted.value = true;
    };

    const iframeIsLoaded = () => {
      iframeLoaded.value = true;
    };

    const embedUrl = computed(() => {
      if (props.video.video_url.includes('youtube')) {
        const videoId = getYouTubeId(props.video.video_url);

        return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }

      if (props.video.video_url.includes('vimeo')) {
        const videoId = getVimeoId(props.video.video_url);

        return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      }

      return '';
    });

    return {
      videoStarted,
      embedUrl,
      iframeLoaded,
      initVideo,
      iframeIsLoaded,
    };
  },
});
